import { render, staticRenderFns } from "./Gmail.vue?vue&type=template&id=dacfc658&scoped=true&"
import script from "./Gmail.vue?vue&type=script&lang=js&"
export * from "./Gmail.vue?vue&type=script&lang=js&"
import style0 from "./Gmail.vue?vue&type=style&index=0&id=dacfc658&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dacfc658",
  null
  
)

export default component.exports